

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import TraceableError from '@/classes/TraceableError';
import { ICheckoutCartOffer } from '@/interfaces/Checkout';
import { hideModal } from '@/helpers/errors';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

import { IUpsell } from '@/interfaces/Upsell';
import { IOrder } from '@/interfaces/Order';
import { EPaymentMethodTypes } from '@/helpers/enums';

@Component
export default class OtherPaymentMethods extends Vue {

  @Prop()
  private errorCode: string | number;

  @AppModule.Action
  private prepareCheckout: Function;

  @AppModule.Action('prepareUpsell')
  private prepareUpsell: Function;

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Mutation
  private setEnableHiddenMethods: Function;

  @CheckoutModule.State
  private upsell: IUpsell;

  @CheckoutModule.State
  private enableHiddenMethods: boolean;

  @CheckoutModule.State
  private order: IOrder;

  private get isRenewRoute() {
    return this.$route.name === 'renew';
  }

  private get hideButtonOtherPaymentMethods() {
    return !this.isRenewRoute && !this.upsell;
  }

  private hideModal(code: string|number) {
    this.$root.$emit('openUpsellModal', true);
    hideModal(code);
  }

  private otherPaymentMethods(): void {
    if (this.upsell) {
      this.prepareUpsell({
        upsellId: this.upsell.id,
        orderId: this.order.id,
        params: {
          paymentMethod: EPaymentMethodTypes.creditCard,
        },
      });
    } else {
      this.prepareCheckout({
        slug: this.rootOffer.slug,
        enableHiddenMethods: true,
      });

      this.setEnableHiddenMethods(true);
    }

    this.hideModal(this.errorCode);
  }

}
